

import React, { useState } from "react";
import moment from "moment";
import { useSubheader } from "../../../_metronic/layout";
import ListCard from "./ListCard";

const AllnewReports = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Reports");
    return (
        <>
            {/* Card List */}
            <ListCard />
        </>
    );
};

export default AllnewReports;
